export const pillars = ['Clinical', 'Assessment', 'Meal Planning', 'Psychology', 'Supplements', 'Scaling'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'The Clinical Foundation & Practice Workflow',
  desc: 'Understand how to organize your daily practice clearly and step by step, so you can assess and manage patients with confidence — even if you have never run a private clinic before.'
}, {
  n: 2,
  emoji: '📗',
  title: 'Advanced Nutritional Assessment Protocols',
  desc: 'Learn to manage clinical evaluations, anthropometry and biochemistry log protocols, avoiding the most common mistakes professionals make when assessing a new patient.'
}, {
  n: 3,
  emoji: '📙',
  title: 'The Modular Meal Planning System',
  desc: 'Incorporate complete modular structures and portion hierarchies that actually save you hours of work, so you can deliver personalized plans from the first session.'
}, {
  n: 4,
  emoji: '📕',
  title: 'Behavior Change & Patient Psychology',
  desc: 'Follow an organized framework to manage patient adherence, motivational interviewing and lifestyle shifts with clear criteria to prevent dropouts and ensure success.'
}, {
  n: 5,
  emoji: '📓',
  title: 'Supplementation & Evidence-Based Prescribing',
  desc: 'By the end of this volume you will understand dosages, nutrient timing and clinical safety so completely that you can prescribe supplements without second-guessing yourself.'
}, {
  n: 6,
  emoji: '📔',
  title: 'Scaling Your Practice & Personal Branding',
  desc: 'Make real business decisions, set value-based prices and build your professional authority without freezing or doubting your worth in the market.'
}];
export const volumeIncludes = ['Visual step-by-step protocols', 'Assessment criteria + checklists', 'Clinical progression checkpoints', 'Real-world case examples', 'Daily practice workflows', 'Printable tracking sheets', 'Designed for beginner and advanced levels', 'Ready to apply from today'];
export const bonuses = [{
  n: '01',
  title: "The Professional Nutritionist's Workbook 📝",
  desc: 'Stop starting from zero. Get 15 ready-to-use clinical templates including Patient Intake Forms, Medical History logs and Anthropometric trackers. Print them or use them digitally to keep your practice organized and professional from day one.',
  price: '$25',
  cover: 'https://cdn.magicpatterns.com/uploads/jGc9KKqQYiJk9L4XfvcADV/BONO1.png'
}, {
  n: '02',
  title: 'The Clinical Measurement & Tracker Kit 📊',
  desc: 'Data-driven results. A collection of professional tracking sheets to monitor patient biochemistry, body composition and objective progress. Show your patients their evolution with clear, clinical data that builds absolute trust.',
  price: '$22',
  cover: 'https://cdn.magicpatterns.com/uploads/fwqvzQePaWs1S3CcSXYdLa/BONO2.png'
}, {
  n: '03',
  title: 'The 10-Minute Meal Plan Revolution 🥗',
  desc: 'Reclaim your time. A specialized guide to modular meal planning. Stop spending 4 hours on a single menu; use our plug-and-play caloric and macro architectures to deliver personalized plans in record time without losing quality.',
  price: '$19',
  cover: 'https://cdn.magicpatterns.com/uploads/hKXYNN54S55ifb4jafLeqs/BONO3.png'
}, {
  n: '04',
  title: 'The Client Success Educational Handouts 💡',
  desc: 'Increase your perceived value. High-end visual guides (infographics) to hand over to your patients. From "How to read labels" to "Hydration essentials". These handouts educate your clients while positioning you as a premium, high-authority expert.',
  price: '$20',
  cover: 'https://cdn.magicpatterns.com/uploads/7aim5aM4cLP8r2tSSi5cRR/BONO4.png'
}, {
  n: '05',
  title: 'The Private Practice Rapid Setup Checklist 🚀',
  desc: 'Launch your business now. The ultimate 48-hour roadmap to setting up your private practice. We cover everything from EMR software recommendations to payment processing and digital folder organization. No more overthinking — just execution.',
  price: '$17',
  cover: 'https://cdn.magicpatterns.com/uploads/3wTYqZtjnLqfhfFMX6QP5C/BONO5.png'
}];
